<div ng-controller="ConfigurationGeneralController as generalCtrl">
    <c-auto-form config="generalCtrl.autoFormConfig"></c-auto-form>
</div>